export interface ShippingFeatureCopy {
  title: string
  description: string
}

export const getShippingFeatureCopy = (
  hasFreeShipping: boolean | undefined
): ShippingFeatureCopy | null => {
  if (hasFreeShipping === undefined) {
    return {
      title: 'Shipping options at checkout',
      description: 'Rates and delivery choices update for your country.',
    }
  }

  if (hasFreeShipping === false) {
    return null
  }

  return {
    title: 'Free shipping available',
    description: 'Shown for your country when your basket qualifies.',
  }
}
